import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeeService } from '../service/fee.service';

export interface SubgroupDeleteDialogData {
  subgroupId: number;
  subgroupName: string;
  hasData: boolean;
}

@Component({
  selector: 'app-fee-subgroup-delete-dialog',
  templateUrl: './fee-subgroup-delete-dialog.component.html',
  styleUrls: ['./fee-subgroup-delete-dialog.component.scss']
})
export class SubgroupDeleteDialogComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  deleting = false;

  constructor(
    private readonly dialogRef: MatDialogRef<SubgroupDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: SubgroupDeleteDialogData,
    private readonly feeService: FeeService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  confirmDelete(): void {
    if (this.deleting || this.data.hasData) return;
    this.deleting = true;

    this.feeService.deleteSubgroup(this.data.subgroupId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.dialogRef.close(true),
        error: () => { this.deleting = false; }
      });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
